import { useState, useEffect } from "react";
import { X, Phone, MessageSquare } from "lucide-react";

export const ScrollCTAPopup = () => {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("scrollCtaDismissed")) {
      setDismissed(true);
      return;
    }

    const handleScroll = () => {
      const scrollPercent = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight);
      if (scrollPercent > 0.4 && scrollPercent < 0.7) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleDismiss = () => {
    setDismissed(true);
    sessionStorage.setItem("scrollCtaDismissed", "true");
  };

  if (dismissed) return null;

  return (
    <div
      className={`fixed bottom-6 left-1/2 -translate-x-1/2 z-50 transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <div className="relative bg-secondary text-secondary-foreground rounded-xl shadow-2xl px-6 py-4 max-w-md mx-4">
        <button
          onClick={handleDismiss}
          className="absolute -top-2 -right-2 bg-secondary-foreground text-secondary rounded-full p-1 hover:opacity-80 transition-opacity"
          aria-label="Dismiss"
        >
          <X className="h-3.5 w-3.5" />
        </button>

        <p className="text-sm font-semibold mb-2 text-center">Have a project in mind?</p>
        <div className="flex items-center gap-3">
          <a
            href="tel:+19737252395"
            className="flex items-center gap-2 bg-secondary-foreground text-secondary rounded-lg px-4 py-2 font-bold text-sm hover:opacity-90 transition-opacity"
          >
            <Phone className="h-4 w-4" />
            Call Us
          </a>
          <a
            href="sms:+19737252395"
            className="flex items-center gap-2 bg-secondary-foreground text-secondary rounded-lg px-4 py-2 font-bold text-sm hover:opacity-90 transition-opacity"
          >
            <MessageSquare className="h-4 w-4" />
            Text Us
          </a>
        </div>
      </div>
    </div>
  );
};
